import { type PreviewContent } from "@/features/preview/records";
import { buildHref } from "@softmax/web-addresses";
import { site } from "@softmax/web-addresses/discovery";

export function gameHomeHead(content: PreviewContent) {
  const canonical = new URL(
    buildHref({ name: "game.home", game: content.route.game }),
    site.canonicalOrigin,
  ).href;
  const image = new URL(
    `${buildHref({ name: "game.preview", ...content.route })}/opengraph-image`,
    site.canonicalOrigin,
  ).href;
  const title = `${content.name} · Softmax`;
  return {
    meta: [
      { title },
      { name: "description", content: content.blurb },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical },
      { property: "og:title", content: title },
      { property: "og:description", content: content.blurb },
      { property: "og:image", content: image },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: `${content.name} on Softmax` },
    ],
    links: [
      { rel: "canonical", href: canonical },
      {
        rel: "alternate",
        type: "text/markdown",
        href: buildHref({ name: "game.playMarkdown", ...content.route }),
      },
    ],
  };
}
